export function createNewsLink({ slug }: { slug: string }) {
  return `/about/news/${slug}`;
}
